import { Controller } from "@hotwired/stimulus";
import { createMap, fitBounds } from "../../helpers/map_helpers";

export default class extends Controller {
  static targets = ["container"];

  static values = {
    data: Array,
    layer: String,
    farmLat: Number,
    farmLon: Number,
  };

  connect() {
    if (typeof L === "undefined") {
      console.error("Leaflet is not loaded");
      return;
    }

    // Small delay to ensure container is rendered
    setTimeout(() => {
      this.initializeMap();
      this.renderLots();
    }, 100);
  }

  disconnect() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  initializeMap() {
    if (!this.hasContainerTarget) {
      console.error("Map container target not found");
      return;
    }

    this.map = createMap(this.containerTarget, {
      lat: this.farmLatValue || 0,
      lon: this.farmLonValue || 0,
      zoom: 15,
    });
    this.map.getContainer().tabIndex = -1;
  }

  renderLots() {
    if (!this.map) return;
    if (!this.hasDataValue || this.dataValue.length === 0) return;

    const polygonLayers = this.dataValue
      .map((lotData) => {
        if (!lotData.polygon) return null;

        const layer = L.geoJSON(JSON.parse(lotData.polygon)).addTo(this.map);

        layer.on("click", () => {
          if (lotData.url) window.location.href = lotData.url;
        });

        layer.setStyle({
          fillColor: lotData.color,
          fillOpacity: 0.5,
          color: lotData.color,
          weight: 2,
        });

        layer.bindTooltip(lotData.tooltip);
        const popupContent = document.createElement("div");
        popupContent.className = "p-2 text-sm";
        popupContent.textContent = lotData.tooltip;
        layer.bindPopup(popupContent);

        return layer;
      })
      .filter((layer) => layer !== null);

    fitBounds(this.map, polygonLayers, { padding: [20, 20] });
  }
}
